import React, { Component } from 'react';

export class AvisoPrivacidad extends Component {

    render() {
        return (
            <>
                {/*<div id="aviso-title" className="col-12" style={{ textAlign: "center", fontWeight: "bold" }}>*/}
                    {/*<h1>AVISO DE PRIVACIDAD DE DATOS PERSONALES DE ALUMNI</h1>*/}
                {/*</div>*/}
                <div id="aviso-texto" className="col-12">
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>1. INTRODUCCI&Oacute;N</h5>
                        <p style={{ textAlign: "justify" }}>
                            En cumplimiento con la Ley Org&aacute;nica de Protecci&oacute;n de Datos Personales, el presente
                            aviso de privacidad tiene como prop&oacute;sito comunicarle el uso de los datos de Alumni
                            para mantenerlo informado sobre la Escuela Superior Polit&eacute;cnica del Litoral (ESPOL)
                            y brindar oportunidades para que contin&uacute;e involucrado en la vida y actividades de esta.
                            Esto incluye otorgar y comunicar beneficios, servicios con fines administrativos,
                            programas filantr&oacute;picos, educativos y comunitarios, invitaciones a eventos, boletines
                            informativos, entre otras actividades. Adem&aacute;s, de usar su informaci&oacute;n con fines
                            estad&iacute;sticos y para cumplir con la informaci&oacute;n requerida por entidades de acreditaci&oacute;n y rankings nacionales e internacionales.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>2. LA INFORMACI&Oacute;N QUE SOLICITAMOS</h5>
                        <div style={{ textAlign: "justify" }}>
                            <p>Se dispone del formulario de actualizaci&oacute;n de datos en la p&aacute;gina web: <a href="https://alumni.espol.edu.ec" target="_blank">www.alumni.espol.edu.ec</a>.</p>
                            <p>Los datos personales que se recolectar&aacute;n mediante el formulario en l&iacute;nea son los siguientes:</p>
                            <ul>
                                <li>Nombre, datos de contacto y domicilio.</li>
                                <li>Datos de identificaci&oacute;n y nacionalidad.</li>
                                <li>Lugar y fecha de nacimiento.</li>
                                <li>Estado civil y sexo.</li>
                                <li>Auto identificaci&oacute;n de g&eacute;nero y etnia.</li>
                                <li>Datos del perfil de las redes sociales.</li>
                                <li>Informaci&oacute;n laboral e informaci&oacute;n acad&eacute;mica.</li>
                                <li>Otros datos que se determinen necesarios solicitar al graduado.</li>
                            </ul>
                        </div>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>3. RESPONSABLE</h5>
                        <p style={{ textAlign: "justify" }}>
                            El responsable del tratamiento de los datos personales de los alumni es la Gerencia de Relaciones
                            Externas de la ESPOL, km 30.5 v&iacute;a perimetral, el correo electro&oacute;nico de contacto es: alumni@espol.edu.ec.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>4. FINES DEL TRATAMIENTO DE LOS DATOS PERSONALES</h5>
                        <div style={{ textAlign: "justify" }}>
                            <p>
                                Los datos personales que nos faciliten son tratados por las diferentes unidades, &aacute;reas o direcciones de la
                                ESPOL para los siguientes fines:
                            </p>
                            <ul>
                                <li>
                                    Proporcionar informaci&oacute;n sobre carreras de grado y/o programas de postgrados, diplomados, talleres,
                                    cursos o charlas presenciales o virtuales de educaci&oacute;n continua.
                                </li>
                                <li>
                                    Facilitar informaci&oacute;n acerca de oportunidades laborales presentadas en la bolsa de empleo de
                                    la instituci&oacute;n en base a los datos acad&eacute;micos y profesionales remitidos por el titular.
                                </li>
                                <li>
                                    Proporcionar informaci&oacute;n acerca del desarrollo de distintos servicios y beneficios en la
                                    instituci&oacute;n destinados para los graduados.
                                </li>
                                <li>
                                    Proveer de informaci&oacute;n acerca de noticias, eventos, investigaciones y programas
                                    institucionales sean estos acad&eacute;micos, sociales, filantr&oacute;picos, comunitarios, sobre
                                    investigaci&oacute;n, entre otros.
                                </li>
                                <li>
                                    Tener un medio de contacto para responder a sus solicitudes o inquietudes o solicitar su
                                    participaci&oacute;n en programas, proyectos o investigaciones.
                                </li>
                                <li>
                                    Procesar y analizar su informaci&oacute;n laboral y acad&eacute;mica para mejorar los productos y
                                    servicios de la instituci&oacute;n.
                                </li>
                                <li>
                                    Procesar y analizar su informaci&oacute;n laboral y acad&eacute;mica para ser entregada a entidades
                                    nacionales e internacionales de rankings y acreditaciones.
                                </li>
                                <li>
                                    Otorgarle beneficios a trav&eacute;s de convenios con empresas p&uacute;blicas y privadas.
                                </li>
                            </ul>
                            <p>
                                Se le enviar&aacute; mensajes oportunos, relevantes y apropiados a trav&eacute;s de los diferentes medios de comunicaci&oacute;n.
                                Usted puede optar por no recibir comunicaciones de Alumni ESPOL en cualquier momento poni&eacute;ndose en contacto
                                con alumni@espol.edu.ec.
                            </p>
                        </div>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>5. CONSERVACI&Oacute;N</h5>
                        <p style={{ textAlign: "justify" }}>
                            Sus datos ser&aacute;n almacenados y conservados por la ESPOL. En caso de no querer que la instituci&oacute;n trate sus
                            datos personales, la ESPOL no utilizar&aacute; su informaci&oacute;n.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>6. BASE LEGAL DEL TRATAMIENTO</h5>
                        <div style={{ textAlign: "justify" }}>
                            <b>LEY ORG&Aacute;NICA DE EDUCACI&Oacute;N SUPERIOR</b>
                            <p>
                                <u>Art. 142</u>.- Sistema de seguimiento a graduados. - Todas las instituciones del sistema de educaci&oacute;n superior,
                                p&uacute;blicas y particulares, deber&aacute;n instrumentar un sistema de seguimiento a sus graduados y sus resultados
                                ser&aacute;n remitidos para conocimiento del Consejo de Evaluaci&oacute;n, Acreditaci&oacute;n y Aseguramiento de la Calidad de
                                la Educación Superior.
                            </p>
                            <b>LEY ORG&Aacute;NICA DE PROTECCI&Oacute;N DE DATOS PERSONALES</b>
                            <p>
                                <u>Art. 2</u>.- &Aacute;mbito de aplicaci&oacute;n material. - La presente ley se aplicar&aacute; al tratamiento de datos personales
                                contenidos en cualquier tipo de soporte, automatizados o no, as&iacute; como a toda modalidad de uso posterior.
                            </p>
                            <p>
                                <u>Art. 7</u>.- Tratamiento leg&iacute;timo de datos personas. - El tratamiento ser&aacute; leg&iacute;timo y l&iacute;cito si se cumple con
                                alguna de las siguientes condiciones:
                                <ol>
                                    <li>
                                        Por consentimiento del titular para el tratamiento de sus datos personales, para una o varias
                                        finalidades especificas;
                                    </li>
                                </ol>
                            </p>
                            <p>
                                <u>Art. 12</u>.- Derecho a la informaci&oacute;n. - El titular de datos personales tiene derecho a ser informado
                                conforme los principios de lealtad y transparente por cualquier medio sobre:
                                <ol>
                                    <li>Los fines del tratamiento;</li>
                                    <li>La base legal para el tratamiento;</li>
                                    <li>Tipos de tratamiento;</li>
                                    <li>Tiempo de conservaci&oacute;n;</li>
                                    <li>La existencia de una base de datos en la que constan sus datos personales;</li>
                                    <li>El origen de los datos personales cuando no se hayan obtenido directamente del titular;</li>
                                    <li>Otras finalidades y tratamientos ulteriores;</li>
                                    <li>
                                        Identidad y datos de contacto del responsable del tratamiento de datos personales, que incluir&aacute;:
                                        direcci&oacute;n del domicilio legal, n&uacute;mero de tel&eacute;fono y correo electr&oacute;nico;
                                    </li>
                                    <li>
                                        Cuando sea del caso, identidad y datos de contacto del delegado de protecci&oacute;n de datos personales,
                                        que incluir&aacute;: direcci&oacute;n domiciliaria, n&uacute;mero de tel&eacute;fono y correo electr&oacute;nico;
                                    </li>
                                    <li>
                                        Las transferencias o comunicaciones, nacionales o internacionales, de datos personales que pretenda
                                        realizar, incluyendo los destinatarios y sus clases, as&iacute; como las finalidades que motivan la
                                        realizaci&oacute;n de estas y las garant&iacute;as de protecci&oacute;n establecidas;
                                    </li>
                                    <li>Las consecuencias para el titular de los datos personales de su entrega o negativa a ello;</li>
                                    <li>El efecto de suministrar datos personales err&oacute;neos o inexactos;</li>
                                    <li>La posibilidad de revocar el consentimiento;</li>
                                    <li>
                                        La existencia y forma en que pueden hacerse efectivos sus derechos de acceso, eliminaci&oacute;n,
                                        rectificaci&oacute;n y actualizaci&oacute;n, oposici&oacute;n, anulaci&oacute;n, limitaci&oacute;n del tratamiento y a no ser
                                        objeto de una decisi&oacute;n basada &uacute;nicamente en valoraciones automatizadas.
                                    </li>
                                    <li>Los mecanismos para hacer efectivo su derecho a la portabilidad, cuando el titular lo solicite;</li>
                                    <li>
                                        D&oacute;nde y cómo realizar sus reclamos ante el responsable del tratamiento de datos y la Autoridad de
                                        Protección de Datos Personales, y;
                                    </li>
                                    <li>La existencia de valoraciones y decisiones automatizadas, incluida la elaboraci&oacute;n de perfiles. (…)</li>
                                </ol>
                            </p><br />
                        </div>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>7. DESTINATARIOS</h5>
                        <div style={{ textAlign: "justify" }}>
                            <p>
                                Se dar&aacute; acceso a los datos personales de los alumni a las unidades, &aacute;reas o direcciones de la ESPOL y a sus
                                fundaciones, sociedades o empresas p&uacute;blicas.
                            </p>
                            <p>
                                No se comparte informaci&oacute;n a terceros excepto en los siguientes casos:
                            </p>
                            <ul>
                                <li>Cuando as&iacute; lo exija la ley.</li>
                                <li>Si se ha obtenido su permiso previo para hacerlo, el cual puede ser revocado en cualquier momento.</li>
                            </ul>
                            <p>
                                Cuando sea requerido se comparten los datos con terceros de confianza, para lo cual se firmar&aacute; un acuerdo
                                de confidencialidad, y se proporcionar&aacute; s&oacute;lo la informaci&oacute;n que necesitan para realizar sus servicios espec&iacute;ficos.
                            </p>
                            <ul>
                                <li>S&oacute;lo pueden usar los datos personales para los fines establecidos.</li>
                                <li>
                                    Se trabaja en estrecha colaboraci&oacute;n con ellos para garantizar que la privacidad sea respetada
                                    y protegida en todo momento.
                                    </li>
                                <li>
                                    Si se deja de usar sus servicios, cualquiera de los datos en su poder ser&aacute;n eliminados, ilegibles
                                    o irreconocibles de forma definitiva y segura.
                                    </li>
                            </ul>
                            <p>
                                Ejemplos del tipo de terceros con los que se trabaja:
                            </p>
                            <ul>
                                <li>Entidades nacionales e internacionales de rankings y acreditaci&oacute;n.</li>
                                <li>Empresas p&uacute;blicas y privadas que otorgan beneficios a los graduados de la instituci&oacute;n.</li>
                                <li>Organizaciones y fundaciones con las que se tengan convenios.</li>
                            </ul>
                            <p>Tambi&eacute;n se comparte informaci&oacute;n con otras partes a solicitud o consentimiento espec&iacute;fico del titular.</p>
                        </div>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>8. SEGURIDAD DE LOS DATOS PERSONALES</h5>
                        <div style={{ textAlign: "justify" }}>
                            <p>
                                Los datos personales se almacenar&aacute;n de forma segura y de acuerdo con la ley. Se aplicar&aacute;n las medidas
                                necesarias que garanticen la protecci&oacute;n de los datos personales frente a cualquier riesgo, amenaza,
                                vulnerabilidad, accesos no autorizados, p&eacute;rdidas, alteraciones, destrucci&oacute;n o comunicaci&oacute;n accidental o
                                il&iacute;cita en el tratamiento de los datos personales.
                            </p><br />
                            <b>USO DE COOKIES</b>
                            <p>
                                Una cookie es un peque&ntilde;o fichero de texto que se almacena en su navegador cuando visita cualquier página web.
                                Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa p&aacute;gina. Las cookies
                                suelen almacenar informaci&oacute;n de car&aacute;cter t&eacute;cnico, preferencias personales, personalizaci&oacute;n de contenidos,
                                estad&iacute;sticas de uso, enlaces a redes sociales, acceso a cuentas de usuario, etc. El objetivo de la cookie es
                                adaptar el contenido de la web a su perfil y necesidades, sin cookies los servicios ofrecidos por cualquier
                                p&aacute;gina se ver&iacute;an mermados notablemente.
                            </p>
                            <p>
                                El sitio web de alumni utiliza las siguientes cookies propias:
                            </p>
                            <ul>
                                <li>
                                    Cookies de sesi&oacute;n, para garantizar que los usuarios que escriban comentarios en el blog sean humanos
                                    y no aplicaciones automatizadas. De esta forma se combate el spam.
                                    </li>
                            </ul>
                            <p>
                                El sitio web de alumni utiliza las siguientes cookies de terceros:
                            </p>
                            <ul>
                                <li>
                                    Google Analytics: Almacena cookies para poder elaborar estad&iacute;sticas sobre el tr&aacute;fico y volumen de
                                    visitas de esta web. Al utilizar este sitio web est&aacute; consintiendo el tratamiento de informaci&oacute;n
                                    acerca de usted por Google. Por tanto, el ejercicio de cualquier derecho en este sentido deber&aacute;
                                    hacerlo directamente con Google.
                                    </li>
                                <li>
                                    Redes sociales: Cada red social utiliza sus propias cookies para que usted pueda pinchar en botones
                                    del tipo Me gusta o Compartir.
                                    </li>
                            </ul>
                            <p>
                                En cualquier momento podr&aacute; ejercer su derecho de desactivaci&oacute;n o eliminaci&oacute;n de cookies de este sitio web.
                                Estas acciones se realizan de forma diferente en funci&oacute;n del navegador que est&eacute; utilizando.
                            </p>
							<ul>
								<li>
									Esta web ni sus representantes legales se hacen responsables por el contenido y la veracidad de
									las pol&iacute;ticas de privacidad que puedan tener los terceros mencionados en esta pol&iacute;tica de cookies.
                                    </li>
								<li>
									Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe
									efectuar su derecho a eliminaci&oacute;n o desactivaci&oacute;n de estas. Ni esta web ni sus representantes legales
									pueden garantizar la correcta o incorrecta manipulaci&oacute;n de las cookies por parte de los mencionados
									navegadores.
                                    </li>
								<li>
									En algunos casos es necesario instalar cookies para que el navegador no olvide su decisi&oacute;n de no
									aceptaci&oacute;n de estas.
                                    </li>
								<li>
									En el caso de las cookies de Google Analytics, esta empresa almacena las cookies en servidores
									ubicados en Estados Unidos y se compromete a no compartirla con terceros, excepto en los casos en
									los que sea necesario para el funcionamiento del sistema o cuando la ley obligue a tal efecto.
									Seg&uacute;n Google no guarda su direcci&oacute;n IP. Google Inc. es una compa&ntilde;ía adherida al Acuerdo de Puerto
									Seguro que garantiza que todos los datos transferidos serán tratados con un nivel de protección
									acorde a la normativa europea.
                                    </li>
							</ul>
                        </div>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>9. FUTUROS CAMBIOS</h5>
                        <p style={{ textAlign: "justify" }}>
                            Si el tratamiento de la informaci&oacute;n cambia en el futuro, se actualizar&aacute; este aviso con los cambios respectivos.
                            S&oacute;lo se utilizar&aacute;n los datos recopilados desde el momento de la notificaci&oacute;n del cambio en adelante, para estos
                            nuevos prop&oacute;sitos.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>10. DERECHOS</h5>
                        <p style={{ textAlign: "justify" }}>
                            Puede ejercitar en cualquier momento sus derechos de acceso, rectificaci&oacute;n, actualizaci&oacute;n, eliminaci&oacute;n, oposici&oacute;n,
                            o la portabilidad respecto de sus datos personales, de acuerdo a los t&eacute;rminos previstos en la normativa aplicable,
                            dirigi&eacute;ndose por escrito a la direcci&oacute;n electr&oacute;nica: alumni@espol.edu.ec.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>11. VERACIDAD DE LOS DATOS</h5>
                        <p style={{ textAlign: "justify" }}>
                            Usted garantiza que los datos personales facilitados son veraces y se compromete a comunicar cualquier
                            actualizaci&oacute;n de los mismos. Tambi&eacute;n garantiza que, salvo error tipogr&aacute;fico, toda la informaci&oacute;n facilitada
                            corresponde con su situaci&oacute;n real, que est&aacute; al d&iacute;a y es exacta, siendo el &uacute;nico responsable de la inexactitud o
                            falsedad de los datos facilitados y de los perjuicios que pueda causar por ello.
                        </p>
                    </div>
                    <br />
                    <div className="col-12">
                        <h5 style={{ fontWeight: "bold" }}>12. ACEPTACI&Oacute;N Y CONSENTIMIENTO</h5>
                        <p style={{ textAlign: "justify" }}>
                            Usted declara haber sido informado de las condiciones indicadas en este aviso, y consiente expresamente al
                            tratamiento de sus datos personales por parte de la ESPOL, en la forma y para las finalidades indicadas en el
                            presente Aviso de privacidad de datos, incluyendo el uso de cookies.
                        </p>
                    </div>
                </div>
            </>
        );
    }
}

export default AvisoPrivacidad;